import { cnpj } from "cpf-cnpj-validator";
import { cpf } from "cpf-cnpj-validator";
import { normalizeDocument } from "utils/mask";
import * as yup from "yup";

export const SchemaPartnerSearch = yup.object().shape({
  document: yup
    .string()
    .optional()
    .test("validateCpfCnpj", "Documento inválido.", (val: any) => {
      if (val) {
        const document = normalizeDocument(val);

        if (document.length === 11) {
          return cpf.isValid(document);
        }
        if (document.length === 14) {
          return cnpj.isValid(document);
        }
        return false;
      }

      return true;
    }),
  municipal_registration: yup.string().optional(),
  property_registration_number: yup.string().optional(),
  renavam: yup
    .string()
    .optional()
    .test(
      "is-valid-length",
      "Renavam Invalido.",
      (value) => !value || /^\d{9,11}$/.test(value)
    ),
  license_plate: yup
    .string()
    // .required("Placa é obrigatório.")
    .optional()
    .test("validateLicensePlate", "Placa inválida.", (val: any) => {
      if (val) {
        if (val.length === 7) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }),
});
